import restApi from "@plannel/services/utils/rest-api";

const get = () => {
  return restApi.get("/api/company");
};

const getCustomConfig = () => {
  return restApi.get("/api/company/custom-object");
};

const update = params => {
  return restApi.post("/api/company", params);
};

const updateCustomConfig = params => {
  return restApi.post("/api/company/custom-object", params);
};

const companyService = {
  get,
  getCustomConfig,
  update,
  updateCustomConfig
};

export default companyService;